<template>
	<div class="wrap">
		<DelData ref="delDatas"></DelData>
		<Linkwin v-if="false"></Linkwin>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党建共建</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="treeWrap" v-if="$store.state.user.userinfo.flag!=3">
				<tree @treeSelect="treeSelect"></tree>
			</div>
			<div class="datatable">
				<div class="datas">
					<div class="selectbar">
						<div>
							<el-input
								style="margin-right: 10px;width: 200px;"
								placeholder="请输入内容"
								size="small"
								prefix-icon="el-icon-search"
								v-model="getdata.name"
								@input="getdata.page = 1;totalPage = 0;dataList();">
							</el-input>
							<el-select
								size="small"
								style="margin-right: 10px;width: 120px !important;" 
								v-model="getdata.year" placeholder="请选择年份"
								@change="getdata.page = 1;totalPage = 0;dataList();"
								clearable>
								<el-option
									:key="index"
									v-for="(item,index) in $yearList()"
									:label="item"
									:value="item">
								</el-option>
							</el-select>
							<el-select
								size="small"
								style="width: 120px !important;" 
								v-model="getdata.month" placeholder="请选择月份"
								clearable
								@change="getdata.page = 1;totalPage = 0;dataList();">
								<el-option
									:key="index"
									v-for="(item,index) in $monthList()"
									:label="item+'月'"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div>
							<el-button type="primary" size="small" @click="add()">新增</el-button>
							<el-button type="primary"
								size="small" @click="delAll">一键删除</el-button>
						</div>
					</div>
					<div class="selectdata">
						<myTables 
							:tableData="tableData"
							delkey="id"
							@selectList="selectList"
                            :tableHeader="tableHeader"
                            :loading="true" 
							:indexs="false"
							:selection="true"></myTables>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Index from './mixins/index.js'
	export default {
		mixins:[Index]
	}
</script>

<style lang="scss">
	.wrap{
		position: relative;
		height: 100%;
		width: 100%;
		.pic{
			width: 110px !important;
			height: 70px;
			object-fit: cover;
		}
	}
</style>

